// STATE: No lower than 8% and no higher than 10% of the face amount of bond. 
//        $50 minimum.      

// FEDERAL: $50 for bonds up to and inlcuding $450 in liability. 12% of penal 
//          amount for bonds over $450 in liability.

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = null
  if (type === 'STATE') {
    minimum = (bondValue * .08)
    value = (bondValue * .1)
    if (value < 50) {
      value = 50
      minimum = 50
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation